import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Breadcrumbs, Stack, Typography } from '@mui/material';

export const Title = ({ icon, title, subHeader, breadcrumbs, buttons }) => {
  return (
    <Stack direction={'row'} sx={{ alignItems: 'center', width: '100%' }}>
      <Stack direction={'column'}>
        {subHeader && (
          <Typography variant="subtitle1" color="primary.main">
            {icon && <FontAwesomeIcon icon={icon} style={{ marginRight: '5px' }} />}
            <Typography id={'subtitle'} component={'span'} variant="inherit">
              {subHeader}
            </Typography>
          </Typography>
        )}
        {title && (
          <Stack direction={'row'} sx={{ alignItems: 'center', gap: 1 }}>
            {icon && !subHeader && <FontAwesomeIcon icon={icon} style={{ marginRight: '5px', fontSize: '2.2em' }} />}
            {title && (
              <Typography id={'title'} component="span" variant="h3">
                {title}
              </Typography>
            )}
          </Stack>
        )}

        {breadcrumbs && (
          <Breadcrumbs separator={<FontAwesomeIcon icon={fas.faChevronRight} size="xs" />}>
            {breadcrumbs.map((breadcrumb) => (
              <Typography key={breadcrumb}>{breadcrumb}</Typography>
            ))}
          </Breadcrumbs>
        )}
      </Stack>

      <Box sx={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
        {/* Buttons set by parent component (Detail, List, etc.) */}
        {buttons}
      </Box>
    </Stack>
  );
};
